import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks, site } from "../config/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <a
        href="#contenu-principal"
        data-testid="skip-link"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:bg-terracotta focus:text-cream focus:px-4 focus:py-2"
      >
        Aller au contenu principal
      </a>
      <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur border-b border-terracotta/10 shadow-sm">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl flex items-center justify-between h-20">
          <Logo />
          <nav className="hidden lg:flex items-center gap-6" aria-label="Navigation principale">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors hover:text-terracotta ${
                    isActive ? "text-terracotta" : "text-encre"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact#reservation"
              data-testid="nav-cta-reserver"
              className="rounded-full bg-terracotta text-cream px-6 py-2.5 text-sm font-semibold transition-all duration-300 hover:bg-terracotta-dark hover:shadow-lg hover:-translate-y-0.5"
            >
              Réserver / Devis
            </Link>
          </nav>
          <div className="flex lg:hidden items-center gap-3">
            <a href={site.phoneHref} data-testid="nav-phone-mobile" aria-label={`Appeler le ${site.phone}`} className="text-terracotta p-2">
              <Phone className="h-5 w-5" strokeWidth={1.5} />
            </a>
            <button
              type="button"
              data-testid="nav-menu-toggle"
              aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              className="p-2 text-encre"
            >
              {open ? <X className="h-6 w-6" strokeWidth={1.5} /> : <Menu className="h-6 w-6" strokeWidth={1.5} />}
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-40 bg-bordeaux flex flex-col items-center justify-center gap-6 lg:hidden" data-testid="mobile-menu">
          <button
            type="button"
            data-testid="nav-menu-close"
            aria-label="Fermer le menu"
            onClick={() => setOpen(false)}
            className="absolute top-6 right-6 p-2 text-cream"
          >
            <X className="h-7 w-7" strokeWidth={1.5} />
          </button>
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
              className={({ isActive }) =>
                `font-display text-3xl transition-colors ${isActive ? "text-gold" : "text-cream hover:text-gold"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact#reservation"
            data-testid="mobile-nav-cta"
            className="mt-4 rounded-full bg-saffron text-cream px-8 py-3 font-semibold transition-transform hover:-translate-y-0.5"
          >
            Réserver / Devis
          </Link>
          <a href={site.phoneHref} data-testid="mobile-nav-phone" className="mt-2 text-cream/80 text-lg">
            {site.phone}
          </a>
        </div>
      )}
    </>
  );
};
